var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content-az"},[_c('span',[_vm._v(_vm._s(_vm.welcome))]),_c('span',[_c('span',{staticClass:"sysName"},[_vm._v(_vm._s(_vm.sysName))]),_c('span',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }